import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=6b0caff3&scoped=true"
import script from "./ServiceAdd.vue?vue&type=script&lang=js"
export * from "./ServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./ServiceAdd.vue?vue&type=style&index=0&id=6b0caff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0caff3",
  null
  
)

export default component.exports